import DwFormField from '@ui/formfield/DwFormField';
import React from 'react';
const ProfileNameFields = (props) => {
    const { formdef } = props;
    if (window.country == 'JP') {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-6 col-12" },
                    React.createElement(DwFormField, { def: formdef, name: "lastname", autocomplete: "family-name", validTick: true })),
                React.createElement("div", { className: "col-md-6 col-12" },
                    React.createElement(DwFormField, { def: formdef, name: "firstname", autocomplete: "given-name", validTick: true }))),
            React.createElement("div", { className: "row align-bottom" },
                React.createElement("div", { className: "col-md-6 col-12" },
                    React.createElement(DwFormField, { def: formdef, name: "localsurname", autocomplete: "family-name", validTick: true })),
                React.createElement("div", { className: "col-md-6 col-12" },
                    React.createElement(DwFormField, { def: formdef, name: "localname", autocomplete: "given-name", validTick: true })))));
    }
    if (window.country == 'HK') {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-4" },
                    React.createElement(DwFormField, { def: formdef, name: "title", type: "select", autocomplete: "honorific-prefix" })),
                React.createElement("div", { className: "col-md-8" },
                    React.createElement(DwFormField, { def: formdef, name: "lastname", autocomplete: "family-name", validTick: true })),
                React.createElement("div", { className: "col-12" },
                    React.createElement(DwFormField, { def: formdef, name: "firstname", autocomplete: "given-name", validTick: true }))),
            React.createElement("div", { className: "row align-bottom kr-name-field" },
                React.createElement("div", { className: "col-md-6 col-12" },
                    React.createElement(DwFormField, { def: formdef, name: "localsurname", autocomplete: "family-name", validTick: true })),
                React.createElement("div", { className: "col-md-6 col-12" },
                    React.createElement(DwFormField, { def: formdef, name: "localname", autocomplete: "given-name", validTick: true })))));
    }
    if (window.country == 'KR') {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: props.isRegisterForm ? 'row align-bottom' : 'row kr-name-field' },
                React.createElement("div", { className: "col-lg-4 col-4" },
                    React.createElement(DwFormField, { def: formdef, name: "title", type: "select", autocomplete: "honorific-prefix" })),
                React.createElement("div", { className: "col-lg-4 col-md-4 col-8" },
                    React.createElement(DwFormField, { def: formdef, name: "lastname", autocomplete: "family-name", validTick: true })),
                React.createElement("div", { className: "col-lg-4 col-md-4 col-12" },
                    React.createElement(DwFormField, { def: formdef, name: "firstname", autocomplete: "given-name", validTick: true }))),
            React.createElement("div", { className: "row kr-name-field" },
                React.createElement("div", { className: "col-md-6 col-12" },
                    React.createElement(DwFormField, { def: formdef, name: "localsurname", autocomplete: "family-name", validTick: true })),
                React.createElement("div", { className: "col-md-6 col-12" },
                    React.createElement(DwFormField, { def: formdef, name: "localname", autocomplete: "given-name", validTick: true })))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-4" },
                React.createElement(DwFormField, { def: formdef, name: "title", type: "select", autocomplete: "honorific-prefix" })),
            React.createElement("div", { className: "col-8" },
                React.createElement(DwFormField, { def: formdef, name: "firstname", autocomplete: "given-name", validTick: true }))),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-12" },
                React.createElement(DwFormField, { def: formdef, name: "lastname", autocomplete: "family-name", validTick: true })))));
};
export default ProfileNameFields;
